<template>
  <div class="container">
    <div class="row">
      <div :class="filterColumnClass">
        <filters
          v-if="productDataset && productDataset.filter_data"
          :product-dataset="productDataset"
        ></filters>
        <loadingoverlay
          v-if="productDataset && productDataset.filter_data"
          :loadingtext="productDataset.filter_data.loading_text"
        ></loadingoverlay>
      </div>
      <div :class="productColumnClass" class="grid-wrapper">
        <div v-if="productDataset.is_one_filter_selected" class="product-content">
          <h1 v-if="productDataset.filter_title">{{ productDataset.filter_title }}</h1>
          <p v-if="productDataset.filter_description">{{ productDataset.filter_description }}</p>
        </div>
        <div v-else class="product-content">
          <h1 v-if="productDataset.productTitle">{{ productDataset.productTitle }}</h1>
          <p v-if="productDataset.productDescription">{{ productDataset.productDescription }}</p>
        </div>
        <grid
          v-if="productDataset && productDataset.filter_data"
          :product-dataset="productDataset"
        ></grid>
        <load-more-products
          v-if="productDataset && productDataset.filter_data"
          :product-dataset="productDataset"
        ></load-more-products>
        <loadingoverlay
          v-if="productDataset && productDataset.filter_data"
          :loadingtext="productDataset.filter_data.loading_text"
        ></loadingoverlay>
      </div>
    </div>
  </div>
</template>

<script>
import Filters from './filters.vue';
import Grid from './grid.vue';
import LoadMore from './load-more-products.vue';
import LoadingOverlay from '../loading-overlay/loading-overlay.vue';
import 'whatwg-fetch';
import { animate } from 'animejs';

export default {
  name: 'product-list',
  components: {
    Filters,
    Grid,
    'load-more-products': LoadMore,
    loadingoverlay: LoadingOverlay,
  },
  props: {
    initialdata: { type: Object, required: true },
    filterColumnClass: { type: String, required: false, default: 'col-sm-3' },
    productColumnClass: { type: String, required: false, default: 'col-sm-9' },
    urlPushReplacementWhat: { type: String, required: false, default: 'api/' },
    urlPushReplacementWith: { type: String, required: false, default: '' },
  },
  data() {
    return {
      productDataset: this.initialdata,
      scolledToTop: false,
      urlPushReplacement: {
        what: this.urlPushReplacementWhat,
        with: this.urlPushReplacementWith,
      },
    };
  },
  methods: {
    checkStatus(response) {
      if (response.status >= 200 && response.status < 300) {
        return response;
      }

      const error = new Error(response.statusText);
      error.response = response;
      throw error;
    },

    parseJSON(response) {
      return response.json();
    },

    displayOverlay() {
      if (window.eventBus) {
        window.eventBus.$emit('overlay.on');
      }
    },

    getData(apiUrl, pushState = false) {
      this.scolledToTop = false;

      fetch(apiUrl, { credentials: 'include' })
        .then(this.checkStatus.bind(this))
        .then(this.parseJSON.bind(this))
        .then(this.displayOverlay())
        .then(this.onData.bind(this))
        .then(() => {
          this.pushUrl(pushState || apiUrl);
        })
        .catch(this.onError.bind(this));
    },

    onData(data) {
      this.productDataset = data;
      if (window.eventBus) {
        window.eventBus.$emit('overlay.off');
      }

      if (window.eventBus) {
        window.eventBus.$emit('filter::resize');
      }

      if (window.eventBus) {
        window.eventBus.$emit('datasGrid.updated');
      }
    },

    onError(error) {
      console.error('request failed', error);
      if (window.eventBus) {
        window.eventBus.$emit('overlay.off');
      }

      if (window.eventBus) {
        window.eventBus.$emit('filter::resize');
      }
    },
    cleanUrl(url) {
      return url.replace(/\/$/, '');
    },
    pushUrl(url) {
      const cleaned = this.cleanUrl(url);
      history.pushState({}, document.title, cleaned);
    },
    getCorrectUrl(url) {
      return url.replace(this.urlPushReplacement.what, this.urlPushReplacement.with);
    },

    scrollUp() {
      const obj = { top: window.pageYOffset };

      animate(obj, {
        top: 0,
        duration: 500,
        delay: 100,
        ease: 'outSine',
        round: 1,
        OnUpdate: () => {
          window.scrollTo(0, obj.top);
        },
        OnComplete: () => {
          this.scolledToTop = true;
        },
      });
    },
  },
};
</script>
